import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby';
import './ProductList.scss';
import RenderContent from '../../RenderContent';
import Pagination from '../../Pagination';
import { Image } from '../../Image';
import ProductListItem from '../ProductListItem'
import { ProductListNavigation } from '../ProductListNavigation'

export default class IndexPage extends React.Component {
  render() {
    const { posts, title, pageContext, categoryFilter, categories, pathPrefix, siteMetadata, location} = this.props
    return (
      <section className="product-list">
        {location === 'dont-render' && <ProductListNavigation pathPrefix={pathPrefix} categories={categories} posts={posts} pageContext={pageContext} postSlug="/products/"/>}

        <div className="outer">
          <div className="wrap">
            <div className="inner">
              {title && <h4 dangerouslySetInnerHTML={{__html: `Our ${title} Range`}} />}
              <div className="list">
                {posts.map((slide, inedx) => !slide.node.slug.includes('gatsby') && 
                    <ProductListItem key={inedx} data={slide.node} siteMetadata={siteMetadata} pathPrefix={pathPrefix} />
                )}
              </div>
              <Pagination pageContext={pageContext} pathPrefix={pathPrefix} />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

IndexPage.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export const pageQuery = graphql`
  fragment ProductListFields on wordpress__wp_products {
    id
    wordpress_id
    product_category {
      wordpress_id
      name
    }
    title
    slug
    path
    acf {
      content
      featureImage {
        localFile {
          childImageSharp {
            fluid(maxWidth: 670, quality: 70) {
              ... GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
      below_honeycomb {
        image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 670, quality: 70) {
                ... GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
      }
      above_honeycomb {
        image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 670, quality: 70) {
                ... GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
      }
    }
    featured_media {
      source_url
      localFile {
        childImageSharp {
          fluid(maxWidth: 670, quality: 70) {
            ... GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  }
`
